import React from "react";
import type { ManifestAsset } from "../../types.js";

interface Props {
  queued: Set<string>;
  assetsById: Map<string, ManifestAsset>;
  onRemove: (id: string) => void;
  onClear: () => void;
  onCommit: () => void;
  signedIn: boolean;
}

export function QueuePanel({ queued, assetsById, onRemove, onClear, onCommit, signedIn }: Props) {
  if (queued.size === 0) return null;
  const ids = [...queued];
  return (
    <div className="queue-panel" role="region" aria-label="Disposition queue">
      <div className="queue-panel-header">
        <strong>{queued.size}</strong>
        <span> selected to move</span>
        <button className="queue-panel-clear" onClick={onClear} title="Clear queue">Clear</button>
      </div>
      <ul className="queue-panel-list">
        {ids.slice(0, 6).map((id) => {
          const a = assetsById.get(id);
          return (
            <li key={id} className="queue-panel-item">
              <span className="queue-panel-name" title={a?.name ?? id}>
                {a?.name ?? id}
              </span>
              <button
                className="queue-panel-remove"
                onClick={() => onRemove(id)}
                aria-label={`Remove ${a?.name ?? id} from queue`}
              >
                ×
              </button>
            </li>
          );
        })}
        {ids.length > 6 && (
          <li className="queue-panel-more">+{ids.length - 6} more</li>
        )}
      </ul>
      <button
        className="queue-panel-commit"
        onClick={onCommit}
        disabled={!signedIn}
        title={signedIn ? "Move these images to Internal Assets (private) and remove them from public" : "Sign in first"}
      >
        {signedIn ? `Move ${queued.size} to Internal Assets` : "Sign in to continue"}
      </button>
    </div>
  );
}
